<cp-header *ngIf="showHeader"></cp-header>

<!-- The routed views render in the <router-outlet>-->
<div
  class="content"
  [ngClass]="{ 'circle-bgd': background === BackgroundType.Circle, 'no-header': !showHeader, 'no-offset': noOffset}"
>
  <div class="router-wrapper">
    <router-outlet></router-outlet>
  </div>

  <div class="circle" *ngIf="background === BackgroundType.Circle"></div>
</div>
